/**
 * Due to MSO compliance, we've decomissioned the 'Normal Safe Fill Level' field and introduced
 * new 'Maximum Working Level' and 'Working Level' fields.
 *
 * TDP is big on retaining historical data, users will expect older receipt plans to display the 'Normal Safe Fill Level'
 * (the 'Intial' version) and newer receipt plans to display the new 'Maximum Working Level' and 'Working Level' fields
 * (the 'PostMSO' version). This means we have to either hide the new or old fields, and use two different calculations
 * in the Receipt Plan and Tanks Monitoring pages.
 *
 * This Schema Version from the TankPlan model (backend) will help determine which version of the fields and calculations
 * should be used in front end
 *
 * JIRA Epic: https://zenergy.atlassian.net/browse/SUP-793
 * 
 * This is currently feature flagged: https://zenergy.atlassian.net/browse/SUP-1423
 *
 * - Johanah 18/02/2025
 */

export enum TankPlanSchemaVersion {
  Initial = "Initial",
  PostMSO = "PostMSO",
}
